/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

/**
 * Returns the sorted
 * array of objects by the given key.
 *
 * @param  array - array of objects
 * @param  key - the names of the properties to sort by.
 *                 Prefix any name with `-` to sort it in descending order.
 */
export function sortArrayBy(array: any, key: string): [] {
  let sortOrder = 1;
  if (typeof key === 'string' && key.startsWith('-')) {
    sortOrder = -1;
    key = key.substr(1);
  }
  return array.sort((e1: any, e2: any) => {
    if (e1[key] > e2[key]) {
      return 1 * sortOrder;
    }

    if (e1[key] < e2[key]) {
      return -1 * sortOrder;
    }

    return 0;
  });
}
